import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy, ViewChild, ElementRef } from "@angular/core";
import { CoreLogService } from "../../services/log.service";
import { SnackBarService, snackBarMessageKey } from "../../services/snackBar.service";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { ActivatedRoute, Router } from "@angular/router";
import { RouterHelperService } from "../../services/routerHelper.service";
import { Observable, Subscription } from "rxjs";
import { SnackBarMessageType } from "../../shared/contentTypes";
import { Location } from "@angular/common";
import { MatRadioButton } from "@angular/material";
import Utils from "../../shared/utils";
import { WebShopService } from "../../services/webShop.service";
import * as _ from "lodash";
import { CoreLanguageService } from "../../services/language.service";
import { IOSHelperService } from "../../services/IOSHelper.service";
import { MainnavService, ViewType } from "../mainNav/mainnav.service";
import { DeliverySetting, IWebVoucher, IWebVoucherSettings } from "./webVoucherCustomDetail.facade";
import { WebVoucherCustomDetailService } from "./webVoucherCustomDetail.service";
import { BottomSheetHelperService } from "../../services/bottomSheetHelper.service";
import { ContinueShoppingDialogComponent } from "../../modalDialogs";
import { FormControl } from "@angular/forms";
import { ValidatorsConfig } from "../../shared/validator/validator.function";

@Component({
  selector: "webVoucherCustomDetail",
  templateUrl: "./webVoucherCustomDetail.component.html",
  styleUrls: ["./webVoucherCustomDetail.component.scss"],
  providers: [WebVoucherCustomDetailService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class WebVoucherCustomDetailComponent implements OnInit, OnDestroy {

  private _langSubscriber: Subscription;
  private _viewTypeSubscription: Subscription;
  private _priceInputSubscriber: Subscription;

  public priceInputFormControl = new FormControl('', ValidatorsConfig.forCustomWebVoucher())

  public webVoucher_custom$: Observable<IWebVoucher>;
  public webVoucherSettings$: Observable<IWebVoucherSettings>;
  public deliverySettings = DeliverySetting;
  public webVoucherCount$: Observable<number>;
  public countOfPersons$: Observable<number>;
  public deliveryType$: Observable<DeliverySetting>;
  public price$: Observable<number>;
  public sum$: Observable<number>;

  private _webVoucherId: number;
  private _locationId: number;
  private _useBrowserHistory: boolean;
  public serviceId: number;

  public variablePriceInputValue: string;
  public currencySymbol = "NO CURRENCY FOUND";

  public radioBtnDeliveryOptions = DeliverySetting;
  public selectedDeivery: number;
  public matGroupSelectedIndex: number;
  public isSmallView: boolean = false;
  public isDropDownActive: boolean = false;

  constructor(private _internationalisationService: InternationalisationService
    , private _webVoucherCustomDetailService: WebVoucherCustomDetailService
    , private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , private _coreLanguageService: CoreLanguageService
    , private _activatedRoute: ActivatedRoute
    , private _snackBarService: SnackBarService
    , private _router: Router
    , private _location: Location
    , private _routerHelperService: RouterHelperService
    , private _IOSHelperService: IOSHelperService
    , private _webShopService: WebShopService
    , private _mainnavService: MainnavService
    , private _bottomSheetHelperService: BottomSheetHelperService) {
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("WebVoucherCustomDetailComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit() {
    const me = this;
    me.matGroupSelectedIndex = 0;
    me.getRouteData();
    me.init(me._webVoucherId);
    me.webVoucher_custom$ = me._webVoucherCustomDetailService.webVoucher$;
    me.webVoucherSettings$ = me._webVoucherCustomDetailService.webVoucher_settings$;
    me.webVoucherCount$ = me._webVoucherCustomDetailService.count$;
    me.countOfPersons$ = me._webVoucherCustomDetailService.personCount$;
    me.deliveryType$ = me._webVoucherCustomDetailService.deliveryType$;
    me.price$ = me._webVoucherCustomDetailService.price$;
    me.sum$ = me._webVoucherCustomDetailService.sum$;

    me.currencySymbol = me._webShopService.currencySymbol;
    me.serviceId = me._webShopService.getServiceMode();

    me._langSubscriber = this._internationalisationService.localeChanged.subscribe(() => {
      me.PushChanges();
    });

    me._priceInputSubscriber = me.priceInputFormControl.valueChanges.subscribe((value) => {
      me.variablePriceInputValue = value;
      me.PushChanges();
    });

    me.onViewTypeChanges(me._mainnavService.viewType);
    me._viewTypeSubscription = me._mainnavService.observeViewTypeChanges.subscribe((viewType) => {
      me.onViewTypeChanges(viewType);
      me.PushChanges();
    });
    me.PushChanges();
  }

  ngOnDestroy(): void {
    const me = this;
    if (me._langSubscriber) {
      me._langSubscriber.unsubscribe();
    }
    if (me._viewTypeSubscription) {
      me._viewTypeSubscription.unsubscribe();
    }
    if (me._priceInputSubscriber) {
      me._priceInputSubscriber.unsubscribe();
    }
  }

  private getRouteData() {
    const me = this;
    me._webVoucherId = +(me._activatedRoute.snapshot.paramMap.get("webVoucherId"));
    me._locationId = +(me._activatedRoute.snapshot.paramMap.get("locationId"));
    me._useBrowserHistory = me._activatedRoute.snapshot.data["useBrowserHistory"];
  }

  public async init(webVoucherID: number) {
    const me = this;
    await me._webVoucherCustomDetailService.init(webVoucherID);
  }

  private onViewTypeChanges(viewType: ViewType) {
    const me = this;
    me.isSmallView = (viewType === ViewType.Small);
  }

  public displayTabs(hasPreview: boolean): boolean {
    const me = this;
    if (hasPreview) {
      return me.isSmallView ? true : false;
    } else {
      return false;
    }
  }

  /**
   * @param description web voucher long description
   * @returns description depending on drop down 
   */
  public customizeDescription(description: string) {
    const me = this;
    if (!me.isDropDownActive) {
      let count = 200;
      if (description.length > count) {
        let lastIndex = description.substring(0, count).lastIndexOf(' ');
        let ellipsis = "..."
        return description.slice(0, lastIndex) + ellipsis;
      } else {
        return description;
      }
    } else {
      return description;
    }
  }

  public displayColapsable(description: string) {
    const me = this;
    let count = 200;
    return description.length > count ? true : false;
  }

  // format price base on language
  public priceFormatter(price: number): string {
    const me = this;
    return me._webShopService.formatCurrency(price);
  }

  private _usePrintAndPostDelivery: boolean = false;
  public usePrintAndPostDelivery(settings: number): boolean {
    const me = this;
    return me._usePrintAndPostDelivery = settings === me.deliverySettings.MailOrPost;
  }

  public usePostDelivery(settings: number): boolean {
    const me = this;
    return settings === me.deliverySettings.Post;
  }

  public useMailDelivery(settings: number): boolean {
    const me = this;
    return settings === me.deliverySettings.Mail;
  }

  public isPostDeliveryFree(deliveryCost: number) {
    return deliveryCost === 0 ? true : false;
  }

  private _hasFreeAmount: boolean = false;
  public hasFreeAmount(price: number): boolean {
    const me = this;
    return me._hasFreeAmount = price === 0;
  }
  private _useNumberOfPersons: boolean = false;
  public useNumberOfPersons(useNumberOfPersons: boolean) {
    const me = this;
    return me._useNumberOfPersons = useNumberOfPersons;
  }

  private _webVoucherCount: number = 1;
  public get webVoucherCount(): number {
    return this._webVoucherCount;
  }

  public set webVoucherCount(amount: number) {
    const sanitizedValue = amount.toString().replace(/[,.]/g, '');
    const numericValue = parseInt(sanitizedValue, 10);
    if (!isNaN(numericValue)) {
      this._webVoucherCount = Math.max(1, Math.min(99, numericValue));
    }
  }

  private _personCount: number = 1;
  public get personCount(): number {
    return this._personCount;
  }

  public set personCount(amount: number) {
    const sanitizedValue = amount.toString().replace(/[,.]/g, '');
    const numericValue = parseInt(sanitizedValue, 10);

    if (!isNaN(numericValue)) {
      this._personCount = Math.max(1, Math.min(99, numericValue));
    }
  }

  public onKeyPress(event: KeyboardEvent): void {
    const inputChar = event.key;
    const allowedCharacters = /^[0-9]$/;
    if (!allowedCharacters.test(inputChar) && inputChar !== 'Backspace') {
      event.preventDefault();
    }
  }

  /** webVoucher input placeholder 0.00 € */
  public get webVoucherInputPlaceholder(): string {
    const me = this;
    const placeholer: number = 0;
    return me.priceFormatter(placeholer);
  }

  /** delivery option change by user */
  public deliveryOptionChanged(val: number, mat: MatRadioButton) {
    const me = this;
    return me._webVoucherCustomDetailService.changeDeliveryType(val);
  }

  public setChecked(deliveryType: number, deliverySettings: number): boolean {
    return deliveryType === deliverySettings;
  }

  /**increment number of persons */
  public incrementPersonCount(): void {
    const me = this;
    return me._webVoucherCustomDetailService.incrementPersonCount();
  }

  /**decrement number of persons */
  public decrementPersonCount(): void {
    const me = this;
    return me._webVoucherCustomDetailService.decrementPersonCount();
  }

  public changePersonCount(personsCount: number) {
    const me = this;
    return me._webVoucherCustomDetailService.changePersonCount(personsCount)
  }

  /**increment webVoucher count*/
  public incrementCount(): void {
    const me = this;
    return me._webVoucherCustomDetailService.incrementCount();
  }

  /**decrement webVoucher count*/
  public decrementCount(): void {
    const me = this;
    me._webVoucherCustomDetailService.decrementCount();
  }

  public changeCount(count: number) {
    const me = this;
    me._webVoucherCustomDetailService.changeCount(count);
  }

  public onBlurAmount() {
    const me = this;
    me.setWebView();
  }

  public onFocusAmount(event: FocusEvent) {
    (event.target as HTMLInputElement).select();
  }

  /** webvoucher variable price change*/
  public onInputVariablePriceChange() {
    const me = this;
    let MIN_PRICE = me._webVoucherCustomDetailService.MIN_PRICE;
    let MAX_PRICE = me._webVoucherCustomDetailService.MAX_PRICE;
    let parsedValue = Utils.moneyRound(+(me.variablePriceInputValue.replace(",", ".")));
    if (!Utils.IsNullOrEmpty(me.variablePriceInputValue)) {
      if (parsedValue >= MIN_PRICE) {
        if (parsedValue >= MAX_PRICE) {
          me.variablePriceInputValue = me._webShopService.formatCurrency(MAX_PRICE, false, false);
        }
      } else {
        me.variablePriceInputValue = me._webShopService.formatCurrency(MIN_PRICE, false, false);
      }
    }
    me._webVoucherCustomDetailService.changePrice(parsedValue);
    me.PushChanges();
  }

  public setSum(sum: number): string {
    const me = this;
    return me.priceFormatter(sum);
  }

  public isAddtoCardButtonActive(webVoucherPrice: number): boolean {
    const me = this;
    return webVoucherPrice === 0 ? !Utils.IsNullOrEmpty(me.variablePriceInputValue) : true;
  }

  /** add webvoucher to basket */
  public async addToBasket(event: MouseEvent) {
    const me = this;
    await me._webVoucherCustomDetailService.addToBasket().then(() => {
      me.animateParticleToBasket(event.pageX, event.pageY);
      const itemConfig = me._webVoucherCustomDetailService.getDialogConfig();
      const bottomSheetRef = me._bottomSheetHelperService.open(ContinueShoppingDialogComponent, {
        data: itemConfig,
        panelClass: "mat-bottom-sheet-container-medium"
      });
      bottomSheetRef.afterDismissed().subscribe(() => {
        me._setDefaultSelection();
        me._scrollIntoView();
      })
      me.PushChanges();
    })
  }

  private _scrollIntoView() {
    const me = this;
    if (me.isSmallView) {
      document.getElementById("voucherCustomDetail").scrollIntoView({
        behavior: "smooth"
      });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }

  private _setDefaultSelection() {
    const me = this;
    if (me._hasFreeAmount) {
      me.priceInputFormControl.setValue("");
      me.priceInputFormControl.markAsUntouched();
      const freeAmountVoucherPrice = 0;
      me._webVoucherCustomDetailService.changePrice(freeAmountVoucherPrice);
    }
    if (!me._hasFreeAmount && me._useNumberOfPersons) {
      const MIN_PERSON_COUNT = me._webVoucherCustomDetailService.MIN_PERSON_COUNT
      me._webVoucherCustomDetailService.changePersonCount(MIN_PERSON_COUNT);
    }
    const MIN_COUNT = me._webVoucherCustomDetailService.MIN_COUNT;
    me.changeCount(MIN_COUNT);
    me._usePrintAndPostDelivery ? me._webVoucherCustomDetailService.changeDeliveryType(DeliverySetting.Mail) : "";
  }

  public onInputVariablePriceBlur() {
    const me = this;
    if (me.variablePriceInputValue.length > 0) {
      const parsedValue = Utils.moneyRound(+(me.variablePriceInputValue.replace(",", ".")));
      if (parsedValue > 0) {
        me.variablePriceInputValue = me._webShopService.formatCurrency(parsedValue, false, false);
      } else {
        me.variablePriceInputValue = me._webShopService.formatCurrency(0, false, false);
      }
    }
    me.PushChanges();
    me.setWebView();
  }

  /**solve problem for IOS keyboard. set the page size after closing the keyboard */
  private setWebView() {
    const me = this;
    me._IOSHelperService.setWebviewAfterBlur();
  }

  public isNumberKey(event) {
    const me = this;
    const isDeutsch = me._coreLanguageService.getCurrentLanguage() === "de";
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode === 13) {
      event.target.blur();
    } else {
      if (charCode !== 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
        if (isDeutsch && charCode === 44) {// accept ',' for deutsch language
          // do nothing
        } else {
          return false;
        }
      }
    }

    const regexp = isDeutsch ? /^[+-]?(?=.?\d)\d*(\,\d{0,2})?$/ : /^[+-]?(?=.?\d)\d*(\.\d{0,2})?$/;
    if (regexp.test(event.target.value.slice(0, event.target.selectionStart) + event.key + event.target.value.slice(event.target.selectionStart))) {
      return true;
    } else {
      return false;
    }
  }

  /**When small view is true, navigation back by swiping from left to right.*/
  public SwiperNavigateBack() {
    const me = this;
    if (me.isSmallView == true) {
      me.navigateBack();
    }
  }

  public swipeRightHandler() {
    const me = this;
    if (me.matGroupSelectedIndex > 0) {
      --me.matGroupSelectedIndex;
      me.PushChanges();
    } else {
      this.SwiperNavigateBack();
    }
  }

  public swipeLeftHandler() {
    const me = this;
    if (me.matGroupSelectedIndex < 1) {
      ++me.matGroupSelectedIndex;
      me.PushChanges();
    }
  }

  public navigateBack(): void {
    const me = this;
    if (me._useBrowserHistory) {
      me._location.back();
    } else {
      me._webShopService.HasSingleLocation(me.serviceId)
        .then(response => {
          if (response) {
            me._location.back();
          } else {
            me._routerHelperService.setRouteTargetDataByKey("useBrowserHistory", me._useBrowserHistory);
            me._router.navigate(["/menulocation"], { replaceUrl: true });
          }
        })
        .catch(e => {
          me._coreLogService.error("WebVoucherCustomDetailComponent.navigateBack", "_webShopService.HasSingleLocation", e);
          me._snackBarService.ShowErrorMessageFailed(105);
        });
    }
  }

  private animateParticleToBasket(x: number, y: number) {
    setTimeout(() => {
      const basketIcon = document.getElementById("header-icon-basket");
      if (basketIcon) {
        const basketRect = basketIcon.getBoundingClientRect();
        const dx = basketRect.left;
        const dy = basketRect.bottom;
        const particle = document.createElement("particle");
        particle.className = "addtobasket";
        document.body.appendChild(particle);
        const animation = particle.animate([
          {
            transform: `translate(-50%, -50%) translate(${x}px, ${y}px)`,
            opacity: 1
          },
          {
            offset: 0.9,
            transform: `translate(${x + (dx - x) * 0.9}px, ${y + (dy - y) * 0.9}px)`,
            opacity: 1
          },
          {
            transform: `translate(${dx}px, ${dy}px)`,
            opacity: 0
          }
        ], {
          duration: 1000,
          easing: "cubic-bezier(0, .9, .6, 1)",
          delay: 0
        });
        animation.onfinish = () => {
          particle.remove();
        };
      }
    }, 50);
  }
}